import React, { useEffect, useState } from 'react';
import './ModalMembresia.css';

const BENEFICIOS_FIJOS = [
  "Horas de Coworking en espacios compartidos",
  "Horas de Uso exclusivo de Sala de Reuniones",
  "Impresiones a Color",
  "Impresiones b/n",
  "Café"
];

const UNIDADES = ["horas", "hojas", "global"];

const ModalMembresia = ({ isOpen, onClose, onGuardar, membresiaInicial }) => {
  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [duracion, setDuracion] = useState('');
  const [beneficios, setBeneficios] = useState([]);

  useEffect(() => {
    if (membresiaInicial) {
      setNombre(membresiaInicial.nombre || '');
      setPrecio(membresiaInicial.precio || '');
      setDescripcion(membresiaInicial.descripcion || '');
      setDuracion(membresiaInicial.duracion || '');
      setBeneficios(membresiaInicial.beneficios || generarBeneficiosVacios());
    } else {
      setNombre('');
      setPrecio('');
      setDescripcion('');
      setDuracion('');
      setBeneficios(generarBeneficiosVacios());
    }
  }, [membresiaInicial]);

  const generarBeneficiosVacios = () => {
    return BENEFICIOS_FIJOS.map(nombre => ({
      nombre,
      cantidad: '',
      unidad: '',
      precioUnitario: ''
    }));
  };

  const handleBeneficioChange = (index, field, value) => {
    const actualizados = [...beneficios];
    actualizados[index][field] = value;
    setBeneficios(actualizados);
  };

  const handleSubmit = () => {
    if (!nombre || !precio || !descripcion) {
      alert('❗ Por favor completa todos los campos obligatorios');
      return;
    }

    const data = {
      nombre,
      precio: parseFloat(precio),
      descripcion,
      duracion: duracion ? parseInt(duracion) : null,
      beneficios,
      fechaActualizacion: new Date()
    };

    onGuardar(data);
  };

  if (!isOpen) return null;

  return (
  <div className="modal-overlay">
    <div className="modal-membresia">
      <div className="modal-membresia-header">
        <h3>{membresiaInicial ? 'Editar Membresía' : 'Crear Nueva Membresía'}</h3>
      </div>
            <div className="modal-membresia-body">

        <label>Nombre *</label>
        <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />

        <label>Precio Total (USD) *</label>
        <input type="number" value={precio} onChange={(e) => setPrecio(e.target.value)} />

        <label>Descripción *</label>
        <textarea value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />

        <label>Duración (días)</label>
        <input type="number" value={duracion} onChange={(e) => setDuracion(e.target.value)} />

        <h4>Beneficios Incluidos</h4>
        <table className="beneficios-table">
          <thead>
            <tr>
              <th>Beneficio</th>
              <th>Cantidad</th>
              <th>Unidad</th>
              <th>Precio Unitario</th>
            </tr>
          </thead>
          <tbody>
            {beneficios.map((b, index) => (
              <tr key={index}>
                <td>{b.nombre}</td>
                <td>
                  <input
                    type="text"
                    value={b.cantidad}
                    onChange={(e) => handleBeneficioChange(index, 'cantidad', e.target.value)}
                  />
                </td>
                <td>
                  <select
                    value={b.unidad}
                    onChange={(e) => handleBeneficioChange(index, 'unidad', e.target.value)}
                  >
                    <option value="">--</option>
                    {UNIDADES.map((u, i) => (
                      <option key={i} value={u}>{u}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    value={b.precioUnitario}
                    onChange={(e) => handleBeneficioChange(index, 'precioUnitario', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

        <div className="modal-actions">
          <button onClick={handleSubmit} className="btn-guardar">
            {membresiaInicial ? 'Actualizar' : 'Guardar'}
          </button>
          <button onClick={onClose} className="btn-cerrar">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalMembresia;
